import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import PhotoSwipe from './photoswipe.esm.js';

// FEATURED PRODUCTS TAB
class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.featured-products__btn');
    this.tabs = this.querySelectorAll('.featured-products__tab');
    this.sliderElems = this.querySelectorAll('.featured-products__tab-slider');

    this.init();
  }

  init() {
    this.initSliders();
    this.initTabs();
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.featured-products__tab[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
            button.setAttribute('aria-selected', 'false');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('active');
            tab.setAttribute('aria-hidden', 'true');
          });

          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
          activeTab.classList.add('active');
          activeTab.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  initSliders() {
    this.sliderElems.forEach((sliderElem) => {
      new Swiper(sliderElem, {
        slidesPerView: 1.25,
        spaceBetween: 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
      });
    });
  }
}

customElements.define('featured-products', FeaturedProducts);


// PRODUCT CARD CHOOSE OPTIONS

class ProductCardOptions extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('.product-card__variant-selection');
    this.variantsData = JSON.parse(this.querySelector('.product-variants-json').innerHTML);
    this.productCard = this.closest('.product-card-wrapper');
    this.priceElement = this.productCard.querySelector('.price__container');

    this.select.addEventListener('change', () => {
      let id = +this.select.value;
      this.changeVariant(id);
    });
  }

  changeVariant(id) {
    let currentVariant = null;
    this.variantsData.forEach((variant) => {
      if (variant.id == id) {
        currentVariant = variant;
      }
    });

    if (currentVariant) {
      let isAvailable = currentVariant.available;
      let price = currentVariant.price;
      let comparePrice = currentVariant.compare_at_price;
      let img = currentVariant.featured_image;

      this.changePrice(price, comparePrice);
      this.changeImage(img);
      this.checkAvailability(isAvailable);
      this.changeFormId(id);
    }
  }

  changeFormId(id) {
    let input = this.productCard.querySelector('form input[name="id"]');
    if (input) {
      input.value = id;
    }
  }

  checkAvailability(isAvailable) {
    let btn = this.productCard.querySelector('.quick-add__submit');

    if (btn) {
      if (!isAvailable) {
        btn.querySelector('.sold-out-message').classList.remove('hidden');
        btn.querySelector('.add-to-cart-message').classList.add('hidden');
        btn.disabled = true;
      } else {
        btn.querySelector('.sold-out-message').classList.add('hidden');
        btn.querySelector('.add-to-cart-message').classList.remove('hidden');
        btn.disabled = false;
      }
    }
  }

  changeImage(img) {
    if (img) {
      let id = img.id;
      let variantImageElem = this.productCard.querySelector(`.variant-image[data-image-id="${id}"]`);
      if (variantImageElem) {
        this.productCard.querySelectorAll('.card__media img').forEach((img) => {
          img.style.display = 'none';
        });

        variantImageElem.style.display = 'block';
      }
    }
  }

  changePrice(price, comparePrice) {
    price = price / 100;
    price = (price % 1 === 0) ? price.toFixed(0) : price.toFixed(2);
    let priceText = `$${price}`;

    if (comparePrice > price) {
      comparePrice = comparePrice / 100;
      comparePrice = (comparePrice % 1 === 0) ? comparePrice.toFixed(0) : comparePrice.toFixed(2);
      let comparePriceText = `$${comparePrice}`;

      this.priceElement.innerHTML = `
                <div class="price--on-sale">
                    <div class="price__sale">
                        <span><s class="price-item price-item--regular">${comparePriceText}</s></span>
                        <span class="price-item price-item--sale price-item--last">${priceText}</span>
                    </div>
                </div>
            `;

    } else {
      this.priceElement.innerHTML = `
                <div class="price__regular">
                    <span class="price-item price-item--regular">${priceText}</span>
                </div>
            `;
    }
  }

}

customElements.define('product-card-options', ProductCardOptions);


// INFO TAB SLIDERS
class InfoSliders extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.tab-sliders__btns-item');
    this.tabs = this.querySelectorAll('.tab-sliders__tab');
    this.sliderElems = this.querySelectorAll('.tab-sliders__tab-slider');
    this.slideFocusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([type="hidden"]):not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'iframe',
      'video[controls]',
      'audio[controls]',
      'summary',
      '[tabindex]',
    ].join(',');

    this.init();
  }

  init() {
    this.initSliders();
    this.initTabs();
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.tab-sliders__tab[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
            button.setAttribute('aria-selected', 'false');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('active');
            tab.setAttribute('aria-hidden', 'true');
          });

          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
          activeTab.classList.add('active');
          activeTab.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  getSlideFocusableElements(slide) {
    return Array.from(slide.querySelectorAll(this.slideFocusableSelector));
  }

  disableSlideFocusableElement(element) {
    if (!element.hasAttribute('data-info-slider-tabindex-stored')) {
      element.setAttribute('data-info-slider-tabindex-stored', 'true');

      if (element.hasAttribute('tabindex')) {
        element.setAttribute('data-info-slider-original-tabindex', element.getAttribute('tabindex'));
      }
    }

    element.setAttribute('tabindex', '-1');
  }

  restoreSlideFocusableElement(element) {
    if (!element.hasAttribute('data-info-slider-tabindex-stored')) return;

    if (element.hasAttribute('data-info-slider-original-tabindex')) {
      element.setAttribute('tabindex', element.getAttribute('data-info-slider-original-tabindex'));
    } else {
      element.removeAttribute('tabindex');
    }

    element.removeAttribute('data-info-slider-tabindex-stored');
    element.removeAttribute('data-info-slider-original-tabindex');
  }

  syncSlideFocusability(sliderElem, activeIndex) {
    const activeSlideIndex = Number(activeIndex) || 0;
    const slides = Array.from(sliderElem.querySelectorAll('.swiper-wrapper > .swiper-slide'));

    slides.forEach((slide, index) => {
      const isActive = index === activeSlideIndex;

      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.inert = !isActive;
      slide.toggleAttribute('inert', !isActive);

      this.getSlideFocusableElements(slide).forEach((element) => {
        if (isActive) {
          this.restoreSlideFocusableElement(element);
        } else {
          this.disableSlideFocusableElement(element);
        }
      });
    });
  }

  initSliders() {
    this.sliderElems.forEach((sliderElem) => {
      let swiper = new Swiper(sliderElem, {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 500,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      let navElem = sliderElem.parentNode.querySelector('.slider-custom-navigation');

      const updateCurrentNavigation = (activeIndex) => {
        navElem.querySelectorAll('.slider-custom-navigation__btn').forEach((elem) => {
          elem.classList.remove('active');
          elem.removeAttribute('aria-current');
        });

        let currentNavElem = navElem.querySelector(`.slider-custom-navigation__btn[data-index="${activeIndex}"]`);
        if (currentNavElem) {
          currentNavElem.classList.add('active');
          currentNavElem.setAttribute('aria-current', 'true');
        }
      };

      this.syncSlideFocusability(sliderElem, swiper.activeIndex);
      updateCurrentNavigation(swiper.activeIndex);

      navElem.querySelectorAll('.slider-custom-navigation__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          let index = btn.getAttribute('data-index');
          swiper.slideTo(index);
        });
      });

      swiper.on('slideChange', function () {
        this.syncSlideFocusability(sliderElem, swiper.activeIndex);
        updateCurrentNavigation(swiper.activeIndex);
      }.bind(this));
    });
  }

}

customElements.define('tab-sliders', InfoSliders);


// COMPARE SHOW MORE BTN

let compareShowMoreBtns = document.querySelectorAll('.compare-show-more');

if (compareShowMoreBtns.length) {
  compareShowMoreBtns.forEach((btn) => {
    let table = btn.parentNode.querySelector('.compare__table');
    if (table) {
      if (table.scrollHeight > 812) {
        btn.classList.add('visible');
      }
    }

    btn.addEventListener('click', () => {
      if (table) {
        if (!table.classList.contains('open')) {
          table.classList.add('open');
          btn.textContent = 'Show less';
        } else {
          table.classList.remove('open');
          btn.textContent = 'Show more';
        }
      }
    });
  });
}


// MEGA MENU CUSTOM BUTTONS
let closeMobileMenuBtns = document.querySelectorAll('.menu-drawer__header-close-btn');

if (closeMobileMenuBtns.length) {
  closeMobileMenuBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let detailsElem = btn.closest('.menu-drawer-container');
      let openedSubMenus = document.querySelectorAll('.menu-drawer__menu details.menu-opening .menu-drawer__close-button');

      if (openedSubMenus.length) {
        openedSubMenus.forEach((elem) => {
          elem.click();
        });
      }

      if (detailsElem) {
        detailsElem.querySelector('summary').click();
      }
    });
  });
}


class SearchWindow extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#search-window__results');
    this.closeBtn = this.querySelector('.search-window__close-btn');
    this.overlay = this.querySelector('.search-window__overlay');
    this.searchTriggers = document.querySelectorAll('[data-open-search-window]');
    this.lastFocusedTrigger = null;
    this.focusableSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    this.inertElements = [];
    this.onKeyDown = this.onKeyDown.bind(this);

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.closeBtn.addEventListener('click', () => {
      this.closeWindow();
    });

    this.overlay.addEventListener('click', () => {
      this.closeWindow();
    });

  }

  openWindow(trigger = document.activeElement?.closest?.('[data-open-search-window]')) {
    if (this.classList.contains('open')) {
      this.focusInput();
      return;
    }

    this.lastFocusedTrigger = trigger || this.searchTriggers[0] || null;
    this.classList.add('open');
    this.setTriggerExpanded(true);
    this.setBackgroundInert();
    document.addEventListener('keydown', this.onKeyDown);

    setTimeout(() => {
      this.querySelector('.search-window__window').classList.add('drawer-animation');
    }, 1);

    requestAnimationFrame(() => this.focusInput());
  }

  closeWindow() {
    if (!this.classList.contains('open')) return;

    this.querySelector('.search-window__window').classList.remove('drawer-animation');
    this.setTriggerExpanded(false);
    this.input.setAttribute('aria-expanded', 'false');

    setTimeout(() => {
      this.classList.remove('open');
      document.removeEventListener('keydown', this.onKeyDown);
      this.releaseBackgroundInert();
      this.lastFocusedTrigger?.focus();
    }, 300);
  }

  getFocusableElements() {
    return Array.from(this.querySelectorAll(this.focusableSelector)).filter(element => {
      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  setBackgroundInert() {
    const inertElements = new Set();
    let activeElement = this;

    while (activeElement?.parentElement && activeElement.parentElement !== document.body) {
      Array.from(activeElement.parentElement.children).forEach(element => {
        if (element !== activeElement) inertElements.add(element);
      });

      activeElement = activeElement.parentElement;
    }

    Array.from(document.body.children).forEach(element => {
      if (element !== activeElement) inertElements.add(element);
    });

    this.inertElements = Array.from(inertElements).map(element => ({
      element,
      wasInert: element.inert
    }));

    this.inertElements.forEach(({ element }) => {
      element.inert = true;
    });
  }

  releaseBackgroundInert() {
    this.inertElements.forEach(({ element, wasInert }) => {
      element.inert = wasInert;
    });

    this.inertElements = [];
  }

  focusInput() {
    this.input?.focus({ preventScroll: true });
  }

  onKeyDown(event) {
    if (!this.classList.contains('open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeWindow();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = this.getFocusableElements();

    if (!focusableElements.length) {
      event.preventDefault();
      this.focus({ preventScroll: true });
      return;
    }

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && (document.activeElement === firstFocusableElement || document.activeElement === this)) {
      event.preventDefault();
      lastFocusableElement.focus();
    }

    if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }

  setTriggerExpanded(isExpanded) {
    this.searchTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  }

  onChange() {
    const searchQuery = this.input.value
      .trim()
      .split(' ')
      .filter(item => item.length > 2)
      .join('&q=');

    if (!searchQuery.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchQuery);
  }

  getSearchResults(searchQuery) {
    fetch(`/search/suggest?q=${searchQuery}&resources[type]=product,article&resources[limit_scope]=each&section_id=predictive-search-results`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search-results')
          .innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('search-window', SearchWindow);


let openSearchWindowBtn = document.querySelector('[data-open-search-window]');
let searchWindow = document.querySelector('search-window');

if (openSearchWindowBtn && searchWindow) {
  openSearchWindowBtn.addEventListener('click', (event) => {
    searchWindow.openWindow(event.currentTarget);
  });
}


// Design Features Section
class DesignFeatures extends HTMLElement {
  constructor() {
    super();

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.tabBtns = this.querySelectorAll('.design-features__btns-item');
    this.tabs = this.querySelectorAll('.design-features__tab');
    this.imageContentElem = this.querySelectorAll('.image-content-elem');

    this.init();
  }

  init() {
    if (this.dataset.designFeaturesInitialized === 'true') return;

    this.dataset.designFeaturesInitialized = 'true';

    this.initTabs();
    this.initImageContentElem();
    this.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.onDocumentClick);
  }

  initImageContentElem() {
    this.imageContentElem.forEach((elem) => {
      const trigger = elem.querySelector('.image-content-elem__trigger');

      this.setHotspotState(elem, false);

      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();

        const shouldOpen = !elem.classList.contains('open');

        this.closeAllHotspots(elem);
        this.setHotspotState(elem, shouldOpen);
      });
    });
  }

  initTabs() {
    const activeTab = this.querySelector('.design-features__btns-item.active') || this.tabBtns[0];

    if (activeTab) {
      this.activateTab(activeTab);
    }

    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.activateTab(btn);
      });
    });
  }

  activateTab(btn, shouldFocus = false) {
    const index = btn.getAttribute('data-index');
    const activeTab = this.querySelector(`.design-features__tab[data-index="${index}"]`);

    if (!activeTab) return;

    this.tabBtns.forEach((button) => {
      const isActive = button === btn;

      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;

      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      tab.hidden = !isActive;
    });

    this.closeAllHotspots();

    if (shouldFocus) {
      btn.focus();
    }
  }

  setHotspotState(elem, isOpen) {
    const trigger = elem.querySelector('.image-content-elem__trigger');
    const content = elem.querySelector('.image-content-elem__content');

    elem.classList.toggle('open', isOpen);
    trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (content) {
      content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      content.hidden = !isOpen;
    }
  }

  closeAllHotspots(exceptElem = null) {
    this.imageContentElem.forEach((elem) => {
      if (elem !== exceptElem) {
        this.setHotspotState(elem, false);
      }
    });
  }

  onDocumentClick(event) {
    if (!this.contains(event.target) || !event.target.closest('.image-content-elem')) {
      this.closeAllHotspots();
    }
  }

  onKeyDown(event) {
    const currentTab = event.target.closest('.design-features__btns-item[role="tab"]');

    if (currentTab && this.contains(currentTab)) {
      this.onTabKeyDown(event, currentTab);
      return;
    }

    if (event.key === 'Escape') {
      const openHotspot = this.querySelector('.image-content-elem.open');

      if (!openHotspot) return;

      const trigger = openHotspot.querySelector('.image-content-elem__trigger');

      event.preventDefault();
      this.setHotspotState(openHotspot, false);
      trigger?.focus();
    }
  }

  onTabKeyDown(event, currentTab) {
    const tabList = Array.from(this.tabBtns);
    const currentIndex = tabList.indexOf(currentTab);

    if (currentIndex === -1) return;

    let nextIndex = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % tabList.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + tabList.length) % tabList.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabList.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    this.activateTab(tabList[nextIndex], true);
  }
}

customElements.define('design-features', DesignFeatures);


// PRODUCT SLIDER
class ProductSlider extends HTMLElement {
  constructor() {
    super();

    this.sliderElem = this.querySelector('.swiper');
    this.thumbnails = this.querySelectorAll('.product-slider__thumbnails-item');
    this.swiper = null;

    this.init();
  }

  init() {
    this.initSlider();
    this.initLightbox();
  }

  initLightbox() {


    const lightbox = new PhotoSwipeLightbox({
      gallery: '.product-slider .swiper-wrapper',
      children: 'a',
      pswpModule: PhotoSwipe,
      padding: { top: 64, bottom: 64, left: 0, right: 0 },
      arrowKeys: true,
    });
    lightbox.init();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderElem, {
      slidesPerView: 1.18,
      spaceBetween: 14,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
    });


    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        let index = +thumbnail.getAttribute('data-index');

        this.swiper.slideTo(index);
      });
    });


    this.swiper.on('slideChange', () => {
      let index = +this.swiper.activeIndex;

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove('active');
      });

      this.thumbnails[index].classList.add('active');
    });
  }

  slideTo(index) {
    this.swiper.slideTo(index);
  }

}

customElements.define('product-slider', ProductSlider);


// PRODUCT TABS

// INFO TAB SLIDERS
class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.product-tabs__btns-item');
    this.tabs = this.querySelectorAll('.product__tabs-item');
    this.video = this.querySelector('.product__video-description video');

    this.init();
  }

  init() {
    this.initTabs();

    if (this.video) {
      this.initVideo();
    }
  }

  initVideo() {
    let videoPlayBtn = this.video.parentNode.querySelector('.product__video-description-overlay');

    if (videoPlayBtn) {
      videoPlayBtn.addEventListener('click', () => {
        videoPlayBtn.style.display = 'none';
        this.video.play();
      });
    }
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.product__tabs-item[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
            button.setAttribute('aria-selected', 'false');
          });
          const topicsContainer = this.querySelector('.product-faq-tabs__topics-list');
          if (topicsContainer) {

            const topics = topicsContainer.querySelectorAll('.product-faq-tabs__topics-item');
            const activeLi = this.querySelectorAll('.product-faq-tabs__topics-li-element');

            const applyFilter = (topicName) => {
              activeLi.forEach(li => {
                const liName = (li.dataset.topicFaq || '').toLowerCase().trim();
                li.classList.toggle('hidden', liName !== topicName);
              });
            };

          
            topics.forEach(topic => {
              if (topic.dataset.faqFilterInitialized === 'true') return;
              topic.dataset.faqFilterInitialized = 'true';

              topic.addEventListener('click', () => {
                topics.forEach(t => {
                  t.classList.remove('product-faq-tabs__topics-item--active');
                  t.setAttribute('aria-pressed', 'false');
                });
                topic.classList.add('product-faq-tabs__topics-item--active');
                topic.setAttribute('aria-pressed', 'true');

                const topicName = topic.dataset.topicName.toLowerCase().trim();
                applyFilter(topicName);
              });
            });

        
            const defaultActive = topicsContainer.querySelector('.product-faq-tabs__topics-item--active');
            if (defaultActive) {
              const defaultName = defaultActive.dataset.topicName.toLowerCase().trim();
              applyFilter(defaultName);
            }
          }


          this.tabs.forEach((tab) => {
            tab.classList.remove('opacity-transition-1');
            tab.classList.add('opacity-transition-0');
            tab.classList.remove('active');
          });

          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
          activeTab.classList.add('active');
          setTimeout(() => {
            activeTab.classList.add('opacity-transition-1');
          }, 100);
        }
      });
    });
  }
}

customElements.define('product-tabs', ProductTabs);


// COLLECTION LIST PAGE - GRID COLUMNS BUTTON

class CollectionsColumnsOnMobile extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('button');
    const productGrid = document.querySelector('.shop-by-categories__wrapper');

    buttons.forEach(btn => {
      btn.addEventListener('click', (event) => {
        if (btn.id === 'two-columns') {
          productGrid?.classList.add('two-per-row');
        } else if (btn.id === 'one-column') {
          productGrid?.classList.remove('two-per-row');
        }
      });
    });
  }
}

customElements.define('collections-columns', CollectionsColumnsOnMobile);


// MEGA MENU

const menuItems = document.querySelectorAll('.header__link-with-menu');

const setDesktopMenuOpen = (item, isOpen) => {
  item.classList.toggle('open', isOpen);
  item.querySelector('button.header__menu-item')?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

menuItems.forEach(item => {
  item.addEventListener('mouseenter', () => {
    setDesktopMenuOpen(item, true);
  });

  item.addEventListener('mouseleave', () => {
    setDesktopMenuOpen(item, false);
  });

  item.querySelector('button.header__menu-item')?.addEventListener('click', (event) => {
    event.preventDefault();
    setDesktopMenuOpen(item, !item.classList.contains('open'));
  });

  item.addEventListener('focusout', (event) => {
    if (!item.contains(event.relatedTarget)) {
      setDesktopMenuOpen(item, false);
    }
  });

  item.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && item.classList.contains('open')) {
      event.preventDefault();
      setDesktopMenuOpen(item, false);
      item.querySelector('button.header__menu-item')?.focus();
    }
  });
});


class MegaMenu extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.mega-menu-new__parent-collections-btn');
    const subMenus = this.querySelectorAll('.mega-menu-new__nav');

    const activateMenu = (btn) => {
      let index = btn.getAttribute('data-index');
      let currentMenu = this.querySelector(`.mega-menu-new__nav[data-index="${index}"]`);

      buttons.forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      });
      subMenus.forEach((menu) => {
        menu.classList.remove('active');
        menu.setAttribute('aria-hidden', 'true');
      });

      btn.classList.add('active');
      btn.setAttribute('aria-expanded', 'true');
      currentMenu?.classList.add('active');
      currentMenu?.setAttribute('aria-hidden', 'false');
    };

    buttons.forEach(btn => {
      btn.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        activateMenu(btn);
      });

      btn.addEventListener('focusin', () => {
        activateMenu(btn);
      });

      btn.addEventListener('click', () => {
        if (btn.tagName !== 'A') {
          activateMenu(btn);
        }
      });

      btn.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          activateMenu(btn);
        }
      });
    });
  }
}

customElements.define('mega-menu', MegaMenu);

const mobileMegaMenuDropdownInputs = document.querySelectorAll('.mobile-mega-menu__parent-collection input[type="checkbox"]');

const syncMobileMegaMenuDisclosure = (input, isExpanded = input.checked) => {
  const parent = input.closest('.mobile-mega-menu__parent-collection');
  const label = parent?.querySelector('.mobile-mega-menu__parent-collection-toggle');
  const content = parent?.querySelector('.mobile-mega-menu__parent-collection-items');

  label?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  content?.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');

  if (content) {
    content.inert = !isExpanded;
  }
};

mobileMegaMenuDropdownInputs.forEach(input => {
  const label = input.parentElement.querySelector('.mobile-mega-menu__parent-collection-toggle');

  syncMobileMegaMenuDisclosure(input);

  label?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      label.click();
    }
  });

  input.addEventListener('change', () => {
    mobileMegaMenuDropdownInputs.forEach(otherInput => {
      if (otherInput !== input) {
        otherInput.checked = false;
        const otherContent = otherInput.parentElement.querySelector('.mobile-mega-menu__parent-collection-items');
        otherContent.style.height = '0';
        syncMobileMegaMenuDisclosure(otherInput, false);
      }
    });

    const content = input.parentElement.querySelector('.mobile-mega-menu__parent-collection-items');
    if (input.checked) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }

    syncMobileMegaMenuDisclosure(input);
  });
});

const standaloneFaqSections = document.querySelectorAll('[data-standalone-faq]');

standaloneFaqSections.forEach((faq) => {
  const faqItems = faq.querySelectorAll('.faq-list__item');
  const navigationButtons = faq.querySelectorAll('.main-faq__navigation-button');

  const syncFaqItem = (item) => {
    const input = item.querySelector('input[type="checkbox"]');
    const toggle = item.querySelector('[data-standalone-faq-toggle]');
    const panel = item.querySelector('.faq-list__item-wrapper');
    const isExpanded = Boolean(input?.checked && item.classList.contains('faq-list__item--active'));

    toggle?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');

    if (panel) {
      panel.inert = !isExpanded;
    }
  };

  const syncFaq = () => {
    faqItems.forEach(syncFaqItem);
  };

  faqItems.forEach((item) => {
    const input = item.querySelector('input[type="checkbox"]');
    const toggle = item.querySelector('[data-standalone-faq-toggle]');

    toggle?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle.click();
      }
    });

    input?.addEventListener('change', () => {
      queueMicrotask(syncFaq);
    });
  });

  navigationButtons.forEach((button) => {
    button.addEventListener('click', () => {
      queueMicrotask(syncFaq);
    });
  });

  syncFaq();
});


class CollectionPopup extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector('.collection-popup__close-btn');
    this.overlay = this.querySelector('.collection-popup__overlay');
    this.popupWindow = this.querySelector('.collection-popup__window');
    this.focusableSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, video[controls], [tabindex]:not([tabindex="-1"])';
    this.inertElements = [];
    this.lastFocusedTrigger = null;
    this.closeTimeout = null;
    this.onKeyDown = this.onKeyDown.bind(this);

    this.closeBtn?.addEventListener('click', () => {
      this.closeWindow();
    });

    this.overlay?.addEventListener('click', () => {
      this.closeWindow();
    });
  }

  openWindow(trigger = document.activeElement) {
    clearTimeout(this.closeTimeout);

    if (this.classList.contains('open')) {
      this.focusInitialElement();
      return;
    }

    this.lastFocusedTrigger = trigger || null;
    this.classList.add('open');
    this.setBackgroundInert();
    document.addEventListener('keydown', this.onKeyDown);

    setTimeout(() => {
      this.popupWindow?.classList.add('drawer-animation');
    }, 1);

    requestAnimationFrame(() => this.focusInitialElement());
  }

  closeWindow() {
    if (!this.classList.contains('open')) return;

    clearTimeout(this.closeTimeout);

    let iframeVideo = this.querySelector('iframe');

    if (iframeVideo && window.YT?.Player) {
      let id = iframeVideo.id;

      // Створення плеєра
      let player = new YT.Player(id, {
        events: {
          'onReady': (event) => {
            event.target.pauseVideo(); // Виклик pauseVideo тільки коли плеєр готовий
          },
        },
      });
    }

    this.popupWindow?.classList.remove('drawer-animation');

    this.closeTimeout = setTimeout(() => {
      this.classList.remove('open');
      document.removeEventListener('keydown', this.onKeyDown);
      this.releaseBackgroundInert();

      if (this.lastFocusedTrigger?.isConnected) {
        this.lastFocusedTrigger.focus({ preventScroll: true });
      }

      this.lastFocusedTrigger = null;
    }, 300);
  }

  getFocusableElements() {
    return Array.from(this.querySelectorAll(this.focusableSelector)).filter(element => {
      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  setBackgroundInert() {
    const inertElements = new Set();
    let activeElement = this;

    while (activeElement?.parentElement && activeElement.parentElement !== document.body) {
      Array.from(activeElement.parentElement.children).forEach(element => {
        if (element !== activeElement) inertElements.add(element);
      });

      activeElement = activeElement.parentElement;
    }

    Array.from(document.body.children).forEach(element => {
      if (element !== activeElement) inertElements.add(element);
    });

    this.inertElements = Array.from(inertElements).map(element => ({
      element,
      wasInert: element.inert
    }));

    this.inertElements.forEach(({ element }) => {
      element.inert = true;
    });
  }

  releaseBackgroundInert() {
    this.inertElements.forEach(({ element, wasInert }) => {
      element.inert = wasInert;
    });

    this.inertElements = [];
  }

  focusInitialElement() {
    const focusTarget = this.closeBtn || this.getFocusableElements()[0] || this;

    focusTarget.focus({ preventScroll: true });
  }

  onKeyDown(event) {
    if (!this.classList.contains('open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeWindow();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = this.getFocusableElements();

    if (!focusableElements.length) {
      event.preventDefault();
      this.focus({ preventScroll: true });
      return;
    }

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && (document.activeElement === firstFocusableElement || document.activeElement === this)) {
      event.preventDefault();
      lastFocusableElement.focus();
    }

    if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }
}

customElements.define('collection-popup', CollectionPopup);


class FilterLink extends HTMLElement {
  constructor() {
    super();
    

    this.link = this.querySelector('a[href*="#popup-"]');

    this.link?.addEventListener('click', (e) => {
      e.preventDefault();
      const popupId = this.link.getAttribute('href');
      const targetPopup = document.getElementById(popupId);

      if (!targetPopup) return;

      if (typeof targetPopup.openWindow === 'function') {
        targetPopup.openWindow(this.link);
        return;
      }

      targetPopup.classList.add('open');
      setTimeout(() => {
        targetPopup.querySelector('.collection-popup__window')?.classList.add('drawer-animation');
      }, 1);
    });
  }

}

customElements.define('filter-link', FilterLink);


// COLLECTION VIDEO PLAY BTN

let collectionVideoPlayBtns = document.querySelectorAll('.custom-video-play-btn');

collectionVideoPlayBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    let video = btn.parentNode.querySelector('video');

    btn.style.display = 'none';
    video.play();
  });
});


// MOBILE OPTION SELECT
class MobileOptionSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');

    this.select?.addEventListener('change', (e) => {
      let value = this.select.value;
      let inputs = document.querySelectorAll('input');

      const currentInput = Array.from(inputs).find(input => input.value == value);

      currentInput?.click();
    });
  }

}

customElements.define('mobile-option', MobileOptionSelect);

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-raised-bed-size-select], [data-raised-bed-height-select]');
  if (!select?.value) return;

  window.location.assign(select.value);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-timer-size-select]');
  if (!select?.value) return;

  window.location.assign(select.value);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-water-control-option-select]');
  if (!select?.value) return;

  window.location.assign(select.value);
});

const initializeFeaturedOnIcons = (root = document) => {
  const sections = [];

  if (root.nodeType === Node.ELEMENT_NODE && root.matches('.icons')) {
    sections.push(root);
  }

  root.querySelectorAll?.('.icons').forEach((section) => {
    sections.push(section);
  });

  sections.forEach((section) => {
    section.querySelectorAll('.icons__item--interactive').forEach((item) => {
      if (item.dataset.iconsA11yInitialized === 'true') return;

      const trigger = item.querySelector('[data-icons-trigger]');
      const panel = item.querySelector('[data-icons-panel]');

      if (!trigger || !panel) return;

      item.dataset.iconsA11yInitialized = 'true';

      let isHovering = false;
      let hasFocusWithin = false;
      let isManuallyExpanded = false;
      let isOpenSuppressed = false;

      const updateState = () => {
        const isOpen = !isOpenSuppressed && (isHovering || hasFocusWithin || isManuallyExpanded);

        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        panel.hidden = !isOpen;
        panel.toggleAttribute('hidden', !isOpen);
        panel.inert = !isOpen;
        panel.toggleAttribute('inert', !isOpen);
      };

      item.addEventListener('pointerenter', () => {
        isHovering = true;
        isOpenSuppressed = false;
        updateState();
      });

      item.addEventListener('pointerleave', () => {
        isHovering = false;
        requestAnimationFrame(updateState);
      });

      item.addEventListener('focusin', () => {
        hasFocusWithin = true;
        updateState();
      });

      item.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          hasFocusWithin = item.contains(document.activeElement);

          if (!hasFocusWithin) {
            isOpenSuppressed = false;
          }

          updateState();
        });
      });

      trigger.addEventListener('click', () => {
        isManuallyExpanded = !isManuallyExpanded;
        isOpenSuppressed = !isManuallyExpanded;
        updateState();
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        event.preventDefault();
        isHovering = false;
        isManuallyExpanded = false;
        isOpenSuppressed = true;
        updateState();
        trigger.focus({ preventScroll: true });
      });

      updateState();
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeFeaturedOnIcons());
} else {
  initializeFeaturedOnIcons();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeFeaturedOnIcons(event.target);
});
